<template>
  <div v-show="show" @click.self="dismiss" class="modal-bg">
    <div id="modal-login" class="modal">

      <form @submit.prevent>

        <h1 class="txt-bold">Kirjautuminen</h1>

        <!-- innput - username -->
        <div class="form-field">
          <label for="login-user">Käyttäjätunnus</label>
          <input v-model="username" name="login-user" type="text">
        </div>

        <!-- innput - password -->
        <div class="form-field">
          <label for="login-password">Salasana</label>
          <input v-model="password" name="login-password" type="password">
        </div>

        <button @click="login" class="btn">Kirjaudu</button>

      </form>

      <p v-if="feedback" class="mt-2">{{this.feedback}}</p>

    </div>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  props: {
    show: {
      type: Boolean
    }
  },

  data () {
    return {
      username: null,
      password: null,
      feedback: null
    }
  },

  created () {
    const escapeHandler = e => {
      if (e.key === 'Escape' && this.show) {
        this.dismiss()
      }
    }
    document.addEventListener('keydown', escapeHandler)
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler)
    })
  },

  methods: {
    dismiss () {
      this.$emit('close')
    },

    login () { // ujuta tänne lopuksi cookie ja tee auth-tarkastelu sen kautta
      if (this.username && this.password) {
        this.feedback = 'Kirjaudutaan...'
        firebase.auth().signInWithEmailAndPassword(this.username, this.password)
          .then(() => {
            // .then(cred => {
          // console.log(cred.user);
            this.$cookie.set('isLogged', { expires: '1h' })
            this.$store.dispatch('setLoggedState', true)
            setTimeout(() => {
              this.feedback = null
              this.dismiss()
              this.$router.push({ name: 'manage' })
            }, 1500)
          }).catch(err => {
            this.feedback = err.message
          })
      } else {
        this.feedback = 'Syötä tarvittavat tiedot'
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/styles.scss";

$form-border-color: rgb(200, 200, 200);
#modal-login {
  label {
    display: block;
    font-size: 0.7rem;
    font-weight: 500;
  }
  input[type="text"],
  input[type="password"],
  input[type="number"],
  input[type="email"], {
    height: 25px;
    padding: 0 8px;
    border: 1px solid $form-border-color;
    border-radius: 5px;
  }
  input {
    &:not([type="checkbox"]) { width: 100%; }
    &::-webkit-outer-spin-button, // for hiding input[type="number"] handle
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
  select {
    width: 100%;
    height: 25px;
  }
  textarea {
    resize: none; // removes the handle
    width: 100%;
    padding: 8px;
    border-radius: 5px;
  }
  input:not([type="file"]), textarea, select {
    outline: none;
    border: 1px solid $form-border-color;
    &:focus { border: 1px solid #002064; }
  }
  button {
    // margin-top: 15px;
    // padding: 0.4rem;
  }
}
</style>
